export const getAccounting = state => state.accounting;
